// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@600&family=Roboto:wght@700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Poppins', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #000;
  overflow-x: hidden;
}


code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace , 'Roboto';
}
input:focus{
  outline: none !important;
  border:1px solid black !important;
}

h1, h2, h3, h4, h5, h6, p{
  line-height: 1.02;
}
h1{
  font-size:50px;
  font-weight: 700;
  margin-bottom: 1.022721rem ;
  color: #fff;
  text-align: left;
}

h2{
  font-size:30px;
  font-weight: 700;
  margin-bottom: 1.022721rem ;
  color: #fff;
  text-align: left;
}


h3{
  font-weight: 800;
font-size: 40px;
line-height: 45px;
color: #191919;
margin-bottom: 15px;
}
h4{
  font-size: 26px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 20px;
}
h5{
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
}
p{
  line-height: 25px;
  margin: 0;
  padding: 0;
  width: 100%;
  font-size: 16px;
}
.faded-p{
  color: #515151;
}
a{text-decoration: none;
color: unset;
font-size: unset;
font-weight: unset;}
a:hover{text-decoration: none;
  color: unset;}


.btn{
  font-size: 14px;
  font-weight: 700;
  padding: 0.667rem 2.4901rem;
  border-radius: 1.9565104rem; 
  border: none;
  line-height: normal;
  display: block;
  height: fit-content;
  width: fit-content;
}
.btn:active, .btn:focus{
  
  box-shadow: unset;
}
.btn-primary{
  background: #FAEC24;
  border: 2px solid #000;
  color: #000;
  font-weight: 600;
}

.btn-primary:hover{
  background: #515151;
  color: #FCFAFA;
  border: 2px solid #000;
  }

  .btn-primary:hover path{
   fill: #191919 ;
  }
  .btn-primary {
    --bs-btn-color: #fff;
    --bs-btn-bg: transparent;
    --bs-btn-border-color: transparent;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: transparent;
    --bs-btn-hover-border-color: transparent;
    --bs-btn-focus-shadow-rgb: 49,132,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: transparent;
    --bs-btn-active-border-color: black;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #fff;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: transparent;
}
.btn svg{
	height: 26px;
	margin-left: 10px;
}

.btn-borderless {
  background-color: transparent;
  border:none;
  font-weight: 700;
  font-size: 14px;
  padding: 0;
  color: #F28B20;
  text-decoration: underline;
}

.btn-borderless:hover{

color: #3D5E2F;;
}

.btn-borderless:focus{
box-shadow: unset;
  }
/* .btn-borderless img{

} */


.btn-transparent {
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #191919;
  color: #191919;
  background:transparent;
}

.btn-transparent span img {
  width: 1.6007rem;
  margin-left: 0.667rem;
  height: 16px;
}




img{
  max-width: 100%;
}

input, select{
border: 1px solid #ABADAD !important;
border-radius: 50px ;
padding: 10px 15px !important;
}

input::placeholder {
  font-size: 16px;
}
textarea{
  padding: 15px !important;
  border-radius: 30px !important;
}

.form-check input{
  border-radius: 0 !important;
  padding: 10px !important;
  margin-right: 15px;
}

.full-height{
min-height: calc(100vh - 204px);   /* 204px here is the total height of the header and nav */
}


.page-not-found h1{
color:#F55;

}
.page-not-found h3{
  margin-bottom: 0;
}
.page-under-construction img{
  height: 100px;
  
}
.page-under-construction h3{
  font-size: 20px;
  font-weight: 500;
 color: grey;
}
.banner-slider {
  height: 50vw ; 
  
}
.banner-slider .slick-track{
  height: 100%;
}
.banner-slider .slick-dots{
  bottom: 0;
}
.slick-slider .slick-dots li button::before{
  width: 35px;
  height: 10px;
  background-color: transparent;
  content: "";
  margin-right: 8px;
}
.slick-slider .slick-dots li button{
  width: 43px
}
.slick-slider .slick-dots li {
  width: fit-content
}

.banner-slider .slick-prev, .banner-slider .slick-next{
	height: 45px;
	width: 45px;
	border-radius: 50px;
top: 100%;
position: absolute;
   

}

.banner-slider .slick-prev{
	left: 80vw
}

.banner-slider .slick-next{
  right: 60px;
}


.orange-line{
  position: relative;
}
.orange-line::after{
  content: "";
  width: 70px;
  height: 7px;
  background-color: #F28B20;
  position: absolute;
 top: 28px;
  left: 125px;
  right: auto;
}
.w-95{
  width: 97%;
margin-left: auto;
margin-right: auto;
}

.bold{
  font-weight: 700 !important;
}
@media (max-width: 992px) {
.responsive-col-gap{   
                             /* this class is for putting gap between lhs and rhs of sections. Use this only at needed cols. Because setting section height to 100vh will solve the issue mostly. if not then use this class */
  margin-bottom: 30px;

  
}


.banner-slider {
  height: 60vw ; 
  
}
.full-height{
  min-height:unset;   /* 204px here is the total height of the header and nav */
  }

.banner-slider .slick-prev, .banner-slider .slick-next{
  top: 90%;
}
.banner-slider .slick-prev{
	left: 80%;
}

.banner-slider .slick-next{
  right: 30px;
}
.cr{
  display: flex;
  flex-direction: column-reverse;
}
h4{
  font-size: 24px;
  font-weight: 700;
  line-height: 15px;
  margin-bottom: 10px;
}
}

@media (max-width: 778px) {
  .btn{
    padding: 10px 15px;
    font-size: 13px;
  }
  .btn svg, .btn img{
    max-width: 50px;
  }
  .responsive-col-gap{   
                               /* this class is for putting gap between lhs and rhs of sections. Use this only at needed cols. Because setting section height to 100vh will solve the issue mostly. if not then use this class */
    margin-bottom: 30px;
  
    
  }
  
  
  .banner-slider ,  .banner-slider  .slick-track{
    height: 100vh; 
    width: 100%;
    overflow-x:scroll;
    
  }
  .banner-slider .slick-slide {
    width: 350px !important;
    overflow: hidden;
  }
  .banner-slider .slide img{
    height: calc(100vh - 130px);
  
    max-width: unset;
width: 1200px;
margin-left: -500px;
  }
  .banner-slider .slide button img{
    height: unset;
 width: unset;
  }
  .banner-slider .slide .mask{
    height: calc(100vh - 130px);
  }
  .banner-slider .slide h3,  .banner-slider .slide .p{
    width: 300px !important;
  }
  .banner-slider .slick-dots{
    top: 86%;
  }
  .banner-slider .slick-prev, .banner-slider .slick-next{
    top: 90%;
    height: 25px;
	width: 25px;
  }

  .banner-slider .slick-prev{
    left: 60%;
  }
  
  .banner-slider .slick-next{
    right:40px;
  }

}

@media (max-width:576px){

 
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;AACpB;;;AAKA;EACE;wBACsB;AACxB;AACA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB,eAAe;AACf,iBAAiB;AACjB,cAAc;AACd,mBAAmB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA,EAAE,qBAAqB;AACvB,YAAY;AACZ,gBAAgB;AAChB,kBAAkB,CAAC;AACnB,QAAQ,qBAAqB;EAC3B,YAAY,CAAC;;;AAGf;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB;;EAEA;GACC,cAAc;EACf;EACA;IACE,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;IAClC,0BAA0B;IAC1B,8BAA8B;IAC9B,wCAAwC;IACxC,qCAAqC;IACrC,2BAA2B;IAC3B,+BAA+B;IAC/B,mCAAmC;IACnC,4DAA4D;IAC5D,6BAA6B;IAC7B,iCAAiC;IACjC,2CAA2C;AAC/C;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;AAEA,cAAc;AACd;;AAEA;AACA,iBAAiB;EACf;AACF;;GAEG;;;AAGH;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;;;;AAKA;EACE,eAAe;AACjB;;AAEA;AACA,oCAAoC;AACpC,oBAAoB;AACpB,6BAA6B;AAC7B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;AACA,+BAA+B,IAAI,yDAAyD;AAC5F;;;AAGA;AACA,UAAU;;AAEV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;;AAEf;AACA;EACE,eAAe;EACf,gBAAgB;CACjB,WAAW;AACZ;AACA;EACE,aAAa;;AAEf;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;AACA;EACE;AACF;AACA;EACE;AACF;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB,SAAS;AACT,kBAAkB;;;AAGlB;;AAEA;CACC;AACD;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;CACnB,SAAS;EACR,WAAW;EACX,WAAW;AACb;AACA;EACE,UAAU;AACZ,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;AACA;6BAC6B,iMAAiM;EAC5N,mBAAmB;;;AAGrB;;;AAGA;EACE,aAAa;;AAEf;AACA;EACE,gBAAgB,IAAI,yDAAyD;EAC7E;;AAEF;EACE,QAAQ;AACV;AACA;CACC,SAAS;AACV;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;+BAC6B,iMAAiM;IAC5N,mBAAmB;;;EAGrB;;;EAGA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;;EAEnB;EACA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,2BAA2B;;IAE3B,gBAAgB;AACpB,aAAa;AACb,mBAAmB;EACjB;EACA;IACE,aAAa;CAChB,YAAY;EACX;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,YAAY;CACf,WAAW;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;;;AAGA","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Poppins', serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #000;\n  overflow-x: hidden;\n}\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@600&family=Roboto:wght@700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap\");\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace , 'Roboto';\n}\ninput:focus{\n  outline: none !important;\n  border:1px solid black !important;\n}\n\nh1, h2, h3, h4, h5, h6, p{\n  line-height: 1.02;\n}\nh1{\n  font-size:50px;\n  font-weight: 700;\n  margin-bottom: 1.022721rem ;\n  color: #fff;\n  text-align: left;\n}\n\nh2{\n  font-size:30px;\n  font-weight: 700;\n  margin-bottom: 1.022721rem ;\n  color: #fff;\n  text-align: left;\n}\n\n\nh3{\n  font-weight: 800;\nfont-size: 40px;\nline-height: 45px;\ncolor: #191919;\nmargin-bottom: 15px;\n}\nh4{\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 30px;\n  margin-bottom: 20px;\n}\nh5{\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 700;\n}\np{\n  line-height: 25px;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  font-size: 16px;\n}\n.faded-p{\n  color: #515151;\n}\na{text-decoration: none;\ncolor: unset;\nfont-size: unset;\nfont-weight: unset;}\na:hover{text-decoration: none;\n  color: unset;}\n\n\n.btn{\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0.667rem 2.4901rem;\n  border-radius: 1.9565104rem; \n  border: none;\n  line-height: normal;\n  display: block;\n  height: fit-content;\n  width: fit-content;\n}\n.btn:active, .btn:focus{\n  \n  box-shadow: unset;\n}\n.btn-primary{\n  background: #FAEC24;\n  border: 2px solid #000;\n  color: #000;\n  font-weight: 600;\n}\n\n.btn-primary:hover{\n  background: #515151;\n  color: #FCFAFA;\n  border: 2px solid #000;\n  }\n\n  .btn-primary:hover path{\n   fill: #191919 ;\n  }\n  .btn-primary {\n    --bs-btn-color: #fff;\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: transparent;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: transparent;\n    --bs-btn-hover-border-color: transparent;\n    --bs-btn-focus-shadow-rgb: 49,132,253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: transparent;\n    --bs-btn-active-border-color: black;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #fff;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: transparent;\n}\n.btn svg{\n\theight: 26px;\n\tmargin-left: 10px;\n}\n\n.btn-borderless {\n  background-color: transparent;\n  border:none;\n  font-weight: 700;\n  font-size: 14px;\n  padding: 0;\n  color: #F28B20;\n  text-decoration: underline;\n}\n\n.btn-borderless:hover{\n\ncolor: #3D5E2F;;\n}\n\n.btn-borderless:focus{\nbox-shadow: unset;\n  }\n/* .btn-borderless img{\n\n} */\n\n\n.btn-transparent {\n  font-size: 14px;\n  font-weight: 700;\n  border: 2px solid #191919;\n  color: #191919;\n  background:transparent;\n}\n\n.btn-transparent span img {\n  width: 1.6007rem;\n  margin-left: 0.667rem;\n  height: 16px;\n}\n\n\n\n\nimg{\n  max-width: 100%;\n}\n\ninput, select{\nborder: 1px solid #ABADAD !important;\nborder-radius: 50px ;\npadding: 10px 15px !important;\n}\n\ninput::placeholder {\n  font-size: 16px;\n}\ntextarea{\n  padding: 15px !important;\n  border-radius: 30px !important;\n}\n\n.form-check input{\n  border-radius: 0 !important;\n  padding: 10px !important;\n  margin-right: 15px;\n}\n\n.full-height{\nmin-height: calc(100vh - 204px);   /* 204px here is the total height of the header and nav */\n}\n\n\n.page-not-found h1{\ncolor:#F55;\n\n}\n.page-not-found h3{\n  margin-bottom: 0;\n}\n.page-under-construction img{\n  height: 100px;\n  \n}\n.page-under-construction h3{\n  font-size: 20px;\n  font-weight: 500;\n color: grey;\n}\n.banner-slider {\n  height: 50vw ; \n  \n}\n.banner-slider .slick-track{\n  height: 100%;\n}\n.banner-slider .slick-dots{\n  bottom: 0;\n}\n.slick-slider .slick-dots li button::before{\n  width: 35px;\n  height: 10px;\n  background-color: transparent;\n  content: \"\";\n  margin-right: 8px;\n}\n.slick-slider .slick-dots li button{\n  width: 43px\n}\n.slick-slider .slick-dots li {\n  width: fit-content\n}\n\n.banner-slider .slick-prev, .banner-slider .slick-next{\n\theight: 45px;\n\twidth: 45px;\n\tborder-radius: 50px;\ntop: 100%;\nposition: absolute;\n   \n\n}\n\n.banner-slider .slick-prev{\n\tleft: 80vw\n}\n\n.banner-slider .slick-next{\n  right: 60px;\n}\n\n\n.orange-line{\n  position: relative;\n}\n.orange-line::after{\n  content: \"\";\n  width: 70px;\n  height: 7px;\n  background-color: #F28B20;\n  position: absolute;\n top: 28px;\n  left: 125px;\n  right: auto;\n}\n.w-95{\n  width: 97%;\nmargin-left: auto;\nmargin-right: auto;\n}\n\n.bold{\n  font-weight: 700 !important;\n}\n@media (max-width: 992px) {\n.responsive-col-gap{   \n                             /* this class is for putting gap between lhs and rhs of sections. Use this only at needed cols. Because setting section height to 100vh will solve the issue mostly. if not then use this class */\n  margin-bottom: 30px;\n\n  \n}\n\n\n.banner-slider {\n  height: 60vw ; \n  \n}\n.full-height{\n  min-height:unset;   /* 204px here is the total height of the header and nav */\n  }\n\n.banner-slider .slick-prev, .banner-slider .slick-next{\n  top: 90%;\n}\n.banner-slider .slick-prev{\n\tleft: 80%;\n}\n\n.banner-slider .slick-next{\n  right: 30px;\n}\n.cr{\n  display: flex;\n  flex-direction: column-reverse;\n}\nh4{\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 15px;\n  margin-bottom: 10px;\n}\n}\n\n@media (max-width: 778px) {\n  .btn{\n    padding: 10px 15px;\n    font-size: 13px;\n  }\n  .btn svg, .btn img{\n    max-width: 50px;\n  }\n  .responsive-col-gap{   \n                               /* this class is for putting gap between lhs and rhs of sections. Use this only at needed cols. Because setting section height to 100vh will solve the issue mostly. if not then use this class */\n    margin-bottom: 30px;\n  \n    \n  }\n  \n  \n  .banner-slider ,  .banner-slider  .slick-track{\n    height: 100vh; \n    width: 100%;\n    overflow-x:scroll;\n    \n  }\n  .banner-slider .slick-slide {\n    width: 350px !important;\n    overflow: hidden;\n  }\n  .banner-slider .slide img{\n    height: calc(100vh - 130px);\n  \n    max-width: unset;\nwidth: 1200px;\nmargin-left: -500px;\n  }\n  .banner-slider .slide button img{\n    height: unset;\n width: unset;\n  }\n  .banner-slider .slide .mask{\n    height: calc(100vh - 130px);\n  }\n  .banner-slider .slide h3,  .banner-slider .slide .p{\n    width: 300px !important;\n  }\n  .banner-slider .slick-dots{\n    top: 86%;\n  }\n  .banner-slider .slick-prev, .banner-slider .slick-next{\n    top: 90%;\n    height: 25px;\n\twidth: 25px;\n  }\n\n  .banner-slider .slick-prev{\n    left: 60%;\n  }\n  \n  .banner-slider .slick-next{\n    right:40px;\n  }\n\n}\n\n@media (max-width:576px){\n\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
